import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setShopHomeCms, saveThemeJsonData,fetchCroppedImage } from "../../../../redux/Actions";
import { ColorPicker } from "primereact/colorpicker";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";

const SectionNineBannerThemeTwo = () => {
  const dispatch = useDispatch<any>();
  const [editData, setEditData] = useState<any>({});
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [imagedata, setImagedata] = useState<any>("" || undefined);
  const jsonData: any = useSelector<any>((state) => state.shopHomeJsonList);

  const images: Array<string> = [
    "assets/img/iPhone11.png",
    "assets/img/iPhone13.png",
  ];

  const saveJsonDataToFile = () => {
    dispatch(setShopHomeCms(editData));
    dispatch(saveThemeJsonData(editData));
  };

  const handleChange = (e: any) => {
    const { value, name } = e.target;
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_2: {
        ...prevJsonData.theme_2,
        home: {
          ...prevJsonData.theme_2.home,
          section_9: {
            ...prevJsonData.theme_2.home.section_9,
            [name]: value,
          },
        },
      },
    }));
  };

  const handleImageChange = (image: string) => {
    //Update the banner value in the JSON data
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_2: {
        ...prevJsonData.theme_2,
        home: {
          ...prevJsonData.theme_2.home,
          section_9: {
            ...prevJsonData.theme_2.home.section_9,
            banner: image,
          },
        },
      },
    }));
  };

  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await dispatch(fetchCroppedImage(image));
    if (imageLink != false) {
      handleImageChange(imageLink);
    }
  };

  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("150");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };

  useEffect(() => {
    setEditData(jsonData);
  }, [jsonData]);

  return (
    <>
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section Nine Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">
                      Title<small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={editData?.theme_2?.home?.section_9?.title}
                      onChange={handleChange}
                      maxLength={250}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Paragraph</label>
                    <input
                      type="text"
                      className="form-control"
                      name="paragraph"
                      value={editData?.theme_2?.home?.section_9?.paragraph}
                      onChange={handleChange}
                      maxLength={1200}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Android Link</label>
                    <input
                      type="text"
                      className="form-control"
                      name="android_link"
                      value={editData?.theme_2?.home?.section_9?.android_link}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">IOS Link</label>
                    <input
                      type="text"
                      className="form-control"
                      name="ios_link"
                      value={editData?.theme_2?.home?.section_9?.ios_link}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                      <label className="form-label">Upload Image</label>
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        className="form-control"
                        name="image"
                        onChange={updateImageSectionOne}
                      />
                    </div>
                  </div>
                </div>
              <div className="row">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">header 1 Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h2color"
                        value={
                          editData?.theme_2?.home?.section_9?.h2color
                        }
                      />
                      <ColorPicker
                        name="h2color"
                        format="hex"
                        onChange={handleChange}
                        value={
                          editData?.theme_2?.home?.section_9?.h2color
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">paragraph Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="paracolor"
                        value={
                          editData?.theme_2?.home?.section_9?.paracolor
                        }
                      />
                      <ColorPicker
                        name="paracolor"
                        format="hex"
                        onChange={handleChange}
                        value={
                          editData?.theme_2?.home?.section_9?.paracolor
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
                      <div className="row">
                        <div className="col">
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-md-12">
                                <div className="img-bg active">
                                  <img
                                    src={
                                      editData?.theme_2?.home?.section_9?.banner
                                    }
                                    alt="Card Icon"
                                  />
                                </div>
                              </div>
                              <div className="img-options">
                                <div className="row">
                                  <div className="col-md-12">
                                    <Swiper
                                      spaceBetween={15}
                                      navigation={true}
                                      modules={[Navigation]}
                                      breakpoints={{
                                        640: {
                                          slidesPerView: 1,
                                        },
                                        768: {
                                          slidesPerView: 4,
                                        },
                                        1024: {
                                          slidesPerView: 6,
                                        },
                                      }}
                                      className="homejson-slider"
                                    >
                                      {images.map(
                                        (images: string, index: any) => {
                                          return (
                                            <>
                                              <SwiperSlide>
                                                <div
                                                  className="img-option"
                                                  key={index}
                                                  onClick={() =>
                                                    handleImageChange(images)
                                                  }
                                                >
                                                  <img
                                                    src={images}
                                                    alt="Hero Image"
                                                    className="img-fluid"
                                                  />
                                                </div>
                                              </SwiperSlide>
                                            </>
                                          );
                                        }
                                      )}
                                    </Swiper>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={() => {
                  saveJsonDataToFile();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SectionNineBannerThemeTwo;
